export default __webpack_public_path__ + "static/media/patterns_green.f421b489.svg";